import DropdownButton from "@/components/DropdownButton";
import { STATUS } from "@/config/progress";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface ButtonMoreMenuProps {
  status: number;
  id: number;
  hasImprovementProposal: boolean;
}

function ActionButton({
  status,
  id,
  hasImprovementProposal,
}: ButtonMoreMenuProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const hasProposal =
    status >= STATUS.IMPROVEMENT_PROPOSAL_COMPLETED && hasImprovementProposal;

  return (
    <DropdownButton
      width="180px"
      items={[
        {
          key: "check-submission",
          item: t("check"),
          hide: status !== STATUS.SUBMITTED,
          onClick: () => {
            navigate(`/console/check-submissions/${id}`);
          },
        },
        {
          key: "create-report",
          item: t("create-report"),
          hide: status !== STATUS.ASSESSMENT_GRADED_COMPLETED,
          onClick: () => {
            navigate(`/console/check-submissions/${id}/evaluate`);
          },
        },
        {
          key: "create-proposal",
          item: t("create-proposal"),
          hide: status < STATUS.ASSESSMENT_EVALUATION_COMPLETED,
          onClick: () => {
            navigate(`/console/check-submissions/${id}/proposal`);
          },
        },
        {
          key: "edit-proposal",
          item: t("edit-proposal"),
          hide: status < STATUS.ASSESSMENT_EVALUATION_COMPLETED || !hasProposal,
          onClick: () => {
            navigate(`/console/check-submissions/${id}/proposal`);
          },
        },
        {
          key: "edit-report",
          item: t("edit-report"),
          hide: status < STATUS.ASSESSMENT_EVALUATION_COMPLETED,
          onClick: () => {
            navigate(`/console/check-submissions/${id}/evaluate`);
          },
        },
        {
          key: "manage-report",
          item: t("manage-report"),
          hide: status < STATUS.ASSESSMENT_EVALUATION_COMPLETED,
          onClick: () => {
            window.open(
              `/console/assessment-results/${id}?isFirstTime=true`,
              "_blank",
            );
          },
        },
        {
          key: "manage-proposal",
          hide: !hasProposal,
          item: t("manage-proposal"),
          onClick: () => {
            window.open(`/console/improvement-proposals/${id}`, "_blank");
          },
        },
      ]}
    />
  );
}

export default ActionButton;
